import { createTheme } from '@mui/material/styles';

// Update these brand colors when you need to refresh the app branding.
export const brandColors = {
  secondary: '#ff6b35',
  primary: '#2a9d8f',
};

export const createAppTheme = (colors = brandColors) => createTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
  },

  typography: {
    // Customize the typography
    fontFamily: 'Arial, sans-serif',
    fontSize: 14,
  },

  // Add more customizations as needed
});

const theme = createAppTheme();

export default theme;